import JobAvailabilityDTO from '@src/adapters/dto/job/JobAvailabilityDTO';
import useApi, { ApiOptions } from '../base/useApi';

export interface Params {
  startDate: Date;
  endDate: Date;
  jobId: string;
}

export interface Result {
  availabilities: JobAvailabilityDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/job/availability_for_job/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: true,
  useGCKey: true,
  manualErrorHandling: true,
};

export const useGetAvailabilitiesForJobLazy = (params?: Params) => {
  return useApi<Params, Result>(options, params);
};

export default useGetAvailabilitiesForJobLazy;
